<template>
  <div class="form-group row">
    <label class="col-2 text-right">保障期間</label>
    <div class="col-10 d-inline-grid">
      <!-- 保障期間-1 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="insuranceTime-1"
          :class="{ 'is-invalid': validate.isPeriodTypeErr }"
          v-model="form.periodType"
          value="7"
        />
        <label class="hide-label" for="insuranceTime-1"></label>
        <select
          class="form-control form-control-inline form-wide ml-50 w-100"
          :class="{ 'is-invalid': validate.isBegin_condErr1 }"
          v-model="form.beginCondition1"
        >
          <option value="">請選擇</option>
          <option
            v-for="item in pageControl.coveragePaymentPeriod"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
      <!-- 保障期間-2 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="insuranceTime-2"
          :class="{ 'is-invalid': validate.isPeriodTypeErr }"
          v-model="form.periodType"
          value="8"
        />
        <label class="hide-label" for="insuranceTime-2"></label>
        <select
          class="form-control form-control-inline form-wide ml-50 w-100"
          :class="{ 'is-invalid': validate.isBegin_condErr2 }"
          v-model="form.beginCondition2"
        >
          <option value="">請選擇</option>
          <option
            v-for="item in pageControl.coveragePaymentExpiration"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40" v-if="pageControl.showAfter">之後</span>
      </div>
      <!-- 保障期間-3 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="insuranceTime-3"
          :class="{ 'is-invalid': validate.isPeriodTypeErr }"
          v-model="form.periodType"
          value="2"
        />
        <label class="hide-label" for="insuranceTime-3"></label>
        <select
          class="form-control form-control-inline form-wide ml-50 w-100"
          :class="{ 'is-invalid': validate.isBegin_condErr3 }"
          v-model="form.beginCondition3"
        >
          <option value="">請選擇</option>
          <option
            v-for="item in pageControl.coveragePaymentExpiration"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">到</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isEndErr3 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model.number="form.end3"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isEndUnitErr3 }"
          v-model="form.endUnit3"
        >
          <option
            v-for="item in pageControl.coveragePeriodUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
      <!-- 保障期間-4 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="insuranceTime-4"
          :class="{ 'is-invalid': validate.isPeriodTypeErr }"
          v-model="form.periodType"
          value="5"
        />
        <label class="hide-label" for="insuranceTime-4"></label>
        <select
          class="form-control form-control-inline form-wide ml-50 w-100"
          :class="{ 'is-invalid': validate.isBegin_condErr4 }"
          v-model="form.beginCondition4"
        >
          <option value="">請選擇</option>
          <option
            v-for="item in pageControl.coveragePaymentExpiration"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">，第</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isBeginErr4 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model.number="form.begin4"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isBeginUnitErr4 }"
          v-model="form.beginUnit4"
        >
          <option
            v-for="item in pageControl.coveragePeriodUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">到</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isEndErr4 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model="form.end4"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isEndUnitErr4 }"
          v-model="form.endUnit4"
        >
          <option
            v-for="item in pageControl.coveragePeriodUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
      <!-- 保障期間-5 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="insuranceTime-5"
          :class="{ 'is-invalid': validate.isPeriodTypeErr }"
          v-model="form.periodType"
          value="1"
        />
        <label class="hide-label" for="insuranceTime-5"></label>
        <span class="lh-40 ml-50">第</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isBeginErr5 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model.number="form.begin5"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isBeginUnitErr5 }"
          v-model="form.beginUnit5"
        >
          <option
            v-for="item in pageControl.coveragePeriodUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">到</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isEndErr5 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model="form.end5"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isEndUnitErr5 }"
          v-model="form.endUnit5"
        >
          <option
            v-for="item in pageControl.coveragePeriodUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
      <!-- 保障期間-6 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="insuranceTime-6"
          :class="{ 'is-invalid': validate.isPeriodTypeErr }"
          v-model="form.periodType"
          value="3"
        />
        <label class="hide-label" for="insuranceTime-6"></label>
        <span class="lh-40 ml-50">第</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isBeginErr6 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model.number="form.begin6"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isBeginUnitErr6 }"
          v-model="form.beginUnit6"
        >
          <option
            v-for="item in pageControl.coveragePeriodUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">到</span>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isEnd_CondErr6 }"
          v-model="form.endCondition6"
        >
          <option value="">請選擇</option>
          <option
            v-for="item in pageControl.coveragePaymentExpiration"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
      <!-- 保障期間-7 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="insuranceTime-7"
          :class="{ 'is-invalid': validate.isPeriodTypeErr }"
          v-model="form.periodType"
          value="4"
        />
        <label class="hide-label" for="insuranceTime-7"></label>
        <span class="lh-40 ml-50">第</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isBeginErr7 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model.number="form.begin7"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isBeginUnitErr7 }"
          v-model="form.beginUnit7"
        >
          <option
            v-for="item in pageControl.coveragePeriodUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">之後</span>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "CoveragePagePeriodMulti",
  mixins: [commonMixin],
  data() {
    return {};
  },
  props: {
    pageControl: {
      type: Object,
      default: () => {
        return {};
      },
    },
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
    validate: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
